import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M44 24v3.002a7.003 7.003 0 0 1-12.794 3.932A9.97 9.97 0 0 1 24 34c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10v3.008A2.993 2.993 0 0 0 37 30c1.654 0 3-1.345 3-2.998V24c0-8.837-7.163-16-16-16S8 15.163 8 24s7.163 16 16 16a2 2 0 1 1 0 4C12.954 44 4 35.046 4 24S12.954 4 24 4s20 8.954 20 20zm-14 0a6 6 0 1 0-12 0 6 6 0 0 0 12 0z" fill={color} fillRule="evenodd"/>
    </svg>
)

export default class IconEmail extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
